import { useQuery } from '@tanstack/react-query';
import { checksApi } from '../api/checks';

// The backend only recomputes checks hourly (configurable via CHECKS_INTERVAL_MINUTES);
// polling every minute here just picks up that cached result quickly, it doesn't trigger
// extra work server-side.
export function useChecksSummary() {
  return useQuery({
    queryKey: ['checks', 'summary'],
    queryFn: checksApi.getSummary,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
